import { useTranslation } from 'react-i18next';
import {
    FaFacebook,
    FaTwitter,
    FaPinterestP,
    FaInstagram,
    FaLinkedin,
  } from 'react-icons/fa';
  
  const Footer = () => {
    const { t } = useTranslation();
    return (
      <footer className="bg-gray-10">
        {/* Top Footer Section */}
        <section className="py-16 text-gray-500">
          <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">
            {/* About */}
            <div>
              <h3 className="text-xl font-normal mb-4">{t('about.title')}</h3>
              <img
                src={`/assets/images/homepage/stocknow_logo.png`}
                alt="StockNow"
                className="mb-4"
              />
              <p className="text-md opacity-[0.8] text-gray-500">
                  {t('footer.description')}
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-xl font-normal mb-4">{t('footer.quickLinks')}</h3>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="hover:underline">{t('nav.home')}</a></li>
                <li><a href="#" className="hover:underline">{t('nav.about')}</a></li>
                <li><a href="#" className="hover:underline">{t('nav.services')}</a></li>
                <li><a href="#" className="hover:underline">Blog</a></li>
                <li><a href="#" className="hover:underline">{t('footer.contact')}</a></li>
              </ul>
            </div>

            {/* Services */}
            <div>
              <h3 className="text-xl font-normal mb-4">{t('footer.features')}</h3>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="hover:underline">{t('services.inventoryTracking')}</a></li>
                <li><a href="#" className="hover:underline">{t('services.aiAnalytics')}</a></li>
                <li><a href="#" className="hover:underline">{t('services.customerAlerts')}</a></li>
                <li><a href="#" className="hover:underline">{t('services.restockNotifications')}</a></li>
                <li><a href="#" className="hover:underline">{t('services.orderManagement')}</a></li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-xl font-normal mb-4">{t('footer.contact')}</h3>
              <p className="text-sm mb-2 text-gray-500">
                Road-2, Block -3/A <br />
                East Shibgonj Sylhet-3100 <br />
                UK
              </p>
              <p className="text-sm mb-2 text-gray-500">
                <a href="#" className="hover:underline">support@stocknow.com</a>
              </p>
              <p className="text-sm text-gray-500">Office: (+880) 0823 560 433</p>
            </div>
          </div>
        </section>
  
        {/* Bottom Footer Section */}
        <section className="text-gray-400 py-6">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <div className="flex justify-center space-x-5 mb-3 text-lg">
              <a href="#" className="hover:text-white">
                <FaFacebook />
              </a>
              <a href="#" className="hover:text-white">
                <FaTwitter />
              </a>
              <a href="#" className="hover:text-white">
                <FaPinterestP />
              </a>
              <a href="#" className="hover:text-white">
                <FaInstagram />
              </a>
              <a href="#" className="hover:text-white">
                <FaLinkedin />
              </a>
            </div>
            <p className="text-sm">
              {t('footer.copyright', { year: 2026 })}
            </p>
          </div>
        </section>
      </footer>
    );
  };
  
  export default Footer;
  